<template>
    <v-card-text>
        <div class="pa-4 d-flex align-start" style="gap: 4px">
            <p class="font-16 font-weight-bold mb-0" style="flex: 1">{{ label }}</p>
            <v-dialog v-model="dialog" width="500">
                <template v-slot:activator="{ on, attrs }">
                    <v-btn icon color="primary" class="mt-n1 flex-shrink-0" v-bind="attrs" v-on="on">
                        <v-icon>fa fa-circle-info</v-icon>
                    </v-btn>
                </template>
                <v-card>
                    <v-img :src="image_url"></v-img>
                </v-card>
            </v-dialog>
        </div>
    </v-card-text>
</template>

<script>
export default {
    name: "VCardTitleWithButton",
    props: {
        label: {
            type: String,
            required: true,
        },
        image_url: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            dialog: false,
        };
    },
};
</script>

<style scoped>
.w_90p {
    width: 90%;
}
</style>
